export default "__VITE_ASSET__BQCmWbfy__"